const isDev =
  typeof process !== "undefined" &&
  process.env.REACT_APP_ENVIORNMENT === "development"
let isProdDebugActive = false

const shouldLog = () => isDev || isProdDebugActive

export const logger = {
  log: (...args) => {
    if (shouldLog()) {
      console.log(...args)
    }
  },
  warn: (...args) => {
    if (shouldLog()) {
      console.warn(...args)
    }
  },
  error: (...args) => {
    if (shouldLog()) {
      console.error(...args)
    }
  },
  enable: () => {
    isProdDebugActive = true
    console.log(
      "%c[LOGGER] Production logs ENABLED for this session.",
      "color: #00bcd4; font-weight: bold;"
    )
  },
  disable: () => {
    isProdDebugActive = false
    console.log(
      "%c[LOGGER] Production logs DISABLED.",
      "color: #ff5722; font-weight: bold;"
    )
  },
}

if (typeof window !== "undefined" && !isDev) {
  window.appLogger = logger
}
